import styled, { css } from 'styled-components'
import { colors, font } from '@chegg-ui/theme'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Text = styled.div<{ size?: string }>`
  color: ${(props) => props.theme.colors[props.color] || props.theme.colors.greyDark};
  font-size: ${(props) =>
    props.size ? props.theme.font.text.size[props.size] : props.theme.font.text.size.md};
  font-weight: 300;
  padding-bottom: 8px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: ${({ theme }) => `-${theme.spacing.md}`};
  margin-right: ${({ theme }) => `-${theme.spacing.md}`};
`

export const LegalWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: ${({ theme }) =>
    `${theme.spacing.sm} ${theme.spacing.md} ${theme.spacing.xs}`};
`

export const ContentContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xs};
`

export const Commitment = styled(ContentContainer)`
  width: 100%;
`

interface LinkProps {
  fontSize?: string
  orange?: boolean
  blue?: boolean
  gray?: boolean
  darkGray?: boolean
  pointer?: boolean
}

export const Link = styled.a<LinkProps>`
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : props.theme.font.text.size.sm};
  text-decoration: none;
  background-color: ${colors.white};
  /* ==== Button Styles ===== */
  border: 0 none;
  padding: 0;
  /* ======================== */
  ${(props) =>
    props.orange &&
    css`
      color: ${props.theme.colors.orange};
      &:hover {
        color: ${props.theme.colors.orange};
      }
      &:focus {
        color: ${props.theme.colors.orange};
      }
    `}
  ${(props) =>
    props.blue &&
    css`
      color: ${props.theme.colors.blue};
      &:hover {
        color: ${props.theme.colors.blue};
      }
      &:focus {
        color: ${props.theme.colors.blue};
      }
    `}
    ${(props) =>
    props.gray &&
    css`
      color: ${props.theme.colors.greylighter};
      &:hover {
        color: ${props.theme.colors.orange};
      }
      &:focus {
        color: ${props.theme.colors.grey};
      }
    `}
    ${(props) =>
    props.darkGray &&
    css`
      color: ${colors.grey};
      &:hover {
        color: ${props.theme.colors.black};
      }
      &:focus {
        color: ${props.theme.colors.black};
      }
    `}
    ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
    `}
    /* We'll have the icon control this eventually */
    & > svg {
    font-size: 18px;
    height: 18px;
    width: 18px;
    margin-top: -1px;
    vertical-align: middle;
  }

  /* ==== CCPA DO NOT SELL MY INFO overrides ===== */
  &#ot-sdk-btn.ot-sdk-show-settings {
    font-size: 12px;
    text-decoration: none;
    background: transparent;
    border: 0 none;
    padding: 0;
    color: ${colors.grey};

    &:hover {
      background-color: transparent;
      text-decoration: underline;
      color: ${colors.dark};
    }
    &:focus {
      background-color: transparent;
      outline: 5px auto -webkit-focus-ring-color;
      outline-offset: -2px;
      color: ${colors.dark};
    }
  }
`

export const BorderContainer = styled.div`
  border-top: 1px solid ${(props) => props.theme.border.colors.gray};
`

export const LinkListHeader = styled.h3`
  margin: 0;
  font-weight: 600;
  font-size: ${font.size.px14};
  color: ${colors.dark};
  margin-bottom: ${(props) => props.theme.spacing.md};
`

export const LinkList = styled.ul`
  list-style: none;
  padding-left: 0;
`

export const FooterListItem = styled(Text)`
  font-size: ${(props) => props.theme.font.text.size.sm};
  padding-bottom: ${(props) => props.theme.spacing.md};
`.withComponent('li')

export const FooterContentsContainer = styled.div.attrs({
  role: 'contentinfo',
})`
  border-top: 1px solid ${(props) => props.theme.border.colors.gray};
  background: ${colors.white};
`

export const ColumnContainer = styled.div`
  padding: ${(props) => props.theme.spacing.lg};
  margin: 0 auto;
  max-width: 750px;
  margin-top: 60px;
`

export const Column = styled.div`
  padding-left: ${({ theme }) => theme.spacing.md};
  padding-right: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  width: 50%;
  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    width: 25%;
  }
`
